export default __webpack_public_path__ + "locales/uk-UA/PeopleTranslations.json?hash=97b63f0ebd1809baab3731c5ca125fab";